// Auto-generated by scripts/generate-registry.mjs from packages/modules/swing_badge_keychain/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const swing_badge_keychain: ModuleSchema = {
  "id": "swing_badge_keychain",
  "uniqueId": "B3D_EG45H",
  "createdAt": "2026-10-09T07:16:37.734Z",
  "updatedAt": "2026-10-12T06:15:08.080Z",
  "label": "Phu Nhuan 50",
  "description": "A commemorative circular 3D printed emblem for Phu Nhuan High School's 50th anniversary.",
  "category": "accessories",
  "tags": [
    "keychain",
    "badge"
  ],
  "sliders": [
    {
      "key": "badgeDiameter",
      "label": "Badge Diameter",
      "min": 30,
      "max": 60,
      "default": 40,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "badgeThickness",
      "label": "Center Base Thickness",
      "min": 0.8,
      "max": 1.5,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "rimThickness",
      "label": "Raised Rim Thickness",
      "min": 1.5,
      "max": 3,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "rimWidth",
      "label": "Rim Radial Width",
      "min": 1.5,
      "max": 4,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "rimOffset",
      "label": "Rim Offset",
      "min": 0.8,
      "max": 3,
      "default": 1.5,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "topHoleDiameter",
      "label": "Metal Ring Hole",
      "min": 3,
      "max": 8,
      "default": 5,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "strapWidth",
      "label": "Strap Width",
      "min": 10,
      "max": 20,
      "default": 15,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "strapLength",
      "label": "Strap Length",
      "min": 60,
      "max": 120,
      "default": 85,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "strapThickness",
      "label": "Strap Thickness",
      "min": 0.4,
      "max": 1.2,
      "default": 0.4,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "number50Scale",
      "label": "50 Scale",
      "min": 0.4,
      "max": 2,
      "default": 1.3,
      "step": 0.05,
      "unit": "x"
    },
    {
      "key": "number50OffsetX",
      "label": "50 Move X",
      "min": -15,
      "max": 15,
      "default": 0.5,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "number50OffsetZ",
      "label": "50 Move Z",
      "min": -10,
      "max": 15,
      "default": 2,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "logoPnScale",
      "label": "Logo PN Scale",
      "min": 0.2,
      "max": 3,
      "default": 2.1,
      "step": 0.01,
      "unit": "x"
    },
    {
      "key": "logoPnOffsetX",
      "label": "Logo PN Move X",
      "min": -15,
      "max": 15,
      "default": 7,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "logoPnOffsetZ",
      "label": "Logo PN Move Z",
      "min": -10,
      "max": 15,
      "default": 1.4,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "logoPnRotate",
      "label": "Logo PN Rotate",
      "min": 0,
      "max": 360,
      "default": 0,
      "step": 1,
      "unit": "deg"
    },
    {
      "key": "bannerScale",
      "label": "Banner Scale",
      "min": 0.4,
      "max": 2,
      "default": 1.6,
      "step": 0.05,
      "unit": "x"
    },
    {
      "key": "bannerOffsetX",
      "label": "Banner Move X",
      "min": -15,
      "max": 15,
      "default": 0,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "bannerOffsetZ",
      "label": "Banner Move Z",
      "min": -10,
      "max": 15,
      "default": -10,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "text1976Scale",
      "label": "1976-2026 Scale",
      "min": 0.4,
      "max": 3,
      "default": 2.06,
      "step": 0.01,
      "unit": "x"
    },
    {
      "key": "text1976OffsetX",
      "label": "1976-2026 Move X",
      "min": -20,
      "max": 20,
      "default": 0.64,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "text1976OffsetZ",
      "label": "1976-2026 Move Z",
      "min": -20,
      "max": 20,
      "default": -10,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa1Scale",
      "label": "Hoa Lá 1 Scale",
      "min": 0.2,
      "max": 3,
      "default": 1.29,
      "step": 0.01,
      "unit": "x"
    },
    {
      "key": "hoaLa1OffsetX",
      "label": "Hoa Lá 1 Move X",
      "min": -20,
      "max": 20,
      "default": 0.44,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa1OffsetZ",
      "label": "Hoa Lá 1 Move Z",
      "min": -20,
      "max": 20,
      "default": 12.64,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa1Rotate",
      "label": "Hoa Lá 1 Rotate",
      "min": 0,
      "max": 360,
      "default": 344,
      "step": 1,
      "unit": "deg"
    },
    {
      "key": "hoaLa2Scale",
      "label": "Hoa Lá 2 Scale",
      "min": 0.2,
      "max": 3,
      "default": 1.08,
      "step": 0.01,
      "unit": "x"
    },
    {
      "key": "hoaLa2OffsetX",
      "label": "Hoa Lá 2 Move X",
      "min": -20,
      "max": 20,
      "default": 14.21,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa2OffsetZ",
      "label": "Hoa Lá 2 Move Z",
      "min": -20,
      "max": 20,
      "default": -7.09,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa2Rotate",
      "label": "Hoa Lá 2 Rotate",
      "min": 0,
      "max": 360,
      "default": 359,
      "step": 1,
      "unit": "deg"
    },
    {
      "key": "hoaLa3Scale",
      "label": "Hoa Lá 3 Scale",
      "min": 0.2,
      "max": 3,
      "default": 1,
      "step": 0.01,
      "unit": "x"
    },
    {
      "key": "hoaLa3OffsetX",
      "label": "Hoa Lá 3 Move X",
      "min": -20,
      "max": 20,
      "default": -13.73,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa3OffsetZ",
      "label": "Hoa Lá 3 Move Z",
      "min": -20,
      "max": 20,
      "default": -7.64,
      "step": 0.01,
      "unit": "mm"
    },
    {
      "key": "hoaLa3Rotate",
      "label": "Hoa Lá 3 Rotate",
      "min": 0,
      "max": 360,
      "default": 2,
      "step": 1,
      "unit": "deg"
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "strapTextLeft",
      "label": "Left Strap Text",
      "default": "TRI ÂN QUÁ KHỨ",
      "kind": "textarea",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        5
      ]
    },
    {
      "key": "strapTextCenter",
      "label": "Center Strap Text",
      "default": "KIẾN TẠO TƯƠNG LAI",
      "kind": "textarea",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        6
      ]
    },
    {
      "key": "strapTextRight",
      "label": "Right Strap Text",
      "default": "VỮNG BƯỚC VƯƠN XA",
      "kind": "textarea",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        7
      ]
    }
  ],
  "colorConfigs": [
    {
      "key": "white_pei_badge",
      "label": "White PEI Badge (Equal Thickness Rings)",
      "default": "#ffffff",
      "targetGroupIds": [
        20
      ]
    },
    {
      "key": "badge_core",
      "label": "Round Badge, Raised Rim and Three Integrated Rings",
      "default": "#ffffff",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "anniversary_number",
      "label": "SVG Number 50",
      "default": "#123b8f",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "number_banner_frame",
      "label": "Hoa Lá Border Around 50 and Banner",
      "default": "#facc15",
      "targetGroupIds": [
        16
      ]
    },
    {
      "key": "anniversary_banner",
      "label": "SVG Curved Banner",
      "default": "#123b8f",
      "targetGroupIds": [
        8
      ]
    },
    {
      "key": "banner_anniversary_text",
      "label": "Banner Text 1976 - 2026",
      "default": "#ffffff",
      "targetGroupIds": [
        10
      ]
    },
    {
      "key": "hoa_la_1",
      "label": "Hoa Lá 1",
      "default": "#38bdf8",
      "targetGroupIds": [
        9
      ]
    },
    {
      "key": "hoa_la_2",
      "label": "Hoa Lá 2",
      "default": "#38bdf8",
      "targetGroupIds": [
        11
      ]
    },
    {
      "key": "hoa_la_3",
      "label": "Hoa Lá 3",
      "default": "#38bdf8",
      "targetGroupIds": [
        12
      ]
    },
    {
      "key": "logo_pn_red",
      "label": "Logo PN Red",
      "default": "#da251c",
      "targetGroupIds": [
        13
      ]
    },
    {
      "key": "logo_pn_blue",
      "label": "Logo PN Blue",
      "default": "#007cc2",
      "targetGroupIds": [
        14
      ]
    },
    {
      "key": "logo_pn_purple",
      "label": "Logo PN Dark Blue",
      "default": "#123b8f",
      "targetGroupIds": [
        15
      ]
    },
    {
      "key": "separate_hook_left",
      "label": "Left Separate C-Hook",
      "default": "#123b8f",
      "targetGroupIds": [
        17
      ]
    },
    {
      "key": "separate_hook_center",
      "label": "Center Separate C-Hook",
      "default": "#dc2626",
      "targetGroupIds": [
        18
      ]
    },
    {
      "key": "separate_hook_right",
      "label": "Right Separate C-Hook",
      "default": "#38bdf8",
      "targetGroupIds": [
        19
      ]
    },
    {
      "key": "hanging_strap_left",
      "label": "Left Strap with Eyelet Hole",
      "default": "#123b8f",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "hanging_strap_center",
      "label": "Center Strap with Eyelet Hole",
      "default": "#dc2626",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "hanging_strap_right",
      "label": "Right Strap with Eyelet Hole",
      "default": "#38bdf8",
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "strap_text_left",
      "label": "Left White Text",
      "default": "#ffffff",
      "targetGroupIds": [
        5
      ]
    },
    {
      "key": "strap_text_center",
      "label": "Center White Text",
      "default": "#ffffff",
      "targetGroupIds": [
        6
      ]
    },
    {
      "key": "strap_text_right",
      "label": "Right White Text",
      "default": "#ffffff",
      "targetGroupIds": [
        7
      ]
    }
  ],
  "objects": [
    {
      "id": "white_pei_badge_object",
      "label": "White PEI Badge — Flat Faces and Circular Groove",
      "name": "White PEI Badge — Flat Faces and Circular Groove",
      "color": "#ffffff",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "white_pei_badge",
          "label": "White PEI Badge (Equal Thickness Rings)",
          "name": "White PEI Badge (Equal Thickness Rings)",
          "groupId": 20,
          "colorKey": "white_pei_badge",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "badge_core_object",
      "label": "Round Badge with Three Integrated Rings",
      "name": "Round Badge with Three Integrated Rings",
      "color": "#ffffff",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "badge_core",
          "label": "Round Badge, Raised Rim and Three Integrated Rings",
          "name": "Round Badge, Raised Rim and Three Integrated Rings",
          "groupId": 0,
          "colorKey": "badge_core",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "anniversary_number",
          "label": "SVG Number 50",
          "name": "SVG Number 50",
          "groupId": 1,
          "colorKey": "anniversary_number",
          "defaultColor": "#123b8f",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "number_banner_frame",
          "label": "Hoa Lá Border Around 50 and Banner",
          "name": "Hoa Lá Border Around 50 and Banner",
          "groupId": 16,
          "colorKey": "number_banner_frame",
          "defaultColor": "#facc15",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "anniversary_banner",
          "label": "SVG Curved Banner",
          "name": "SVG Curved Banner",
          "groupId": 8,
          "colorKey": "anniversary_banner",
          "defaultColor": "#123b8f",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "banner_anniversary_text",
          "label": "Banner Text 1976 - 2026",
          "name": "Banner Text 1976 - 2026",
          "groupId": 10,
          "colorKey": "banner_anniversary_text",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "hoa_la_object",
      "label": "Three Separate Leaves",
      "name": "Three Separate Leaves",
      "color": "#38bdf8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "hoa_la_1",
          "label": "Hoa Lá 1",
          "name": "Hoa Lá 1",
          "groupId": 9,
          "colorKey": "hoa_la_1",
          "defaultColor": "#38bdf8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "hoa_la_2",
          "label": "Hoa Lá 2",
          "name": "Hoa Lá 2",
          "groupId": 11,
          "colorKey": "hoa_la_2",
          "defaultColor": "#38bdf8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "hoa_la_3",
          "label": "Hoa Lá 3",
          "name": "Hoa Lá 3",
          "groupId": 12,
          "colorKey": "hoa_la_3",
          "defaultColor": "#38bdf8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "logo_pn_object",
      "label": "Logo PN (logopn.svg)",
      "name": "Logo PN (logopn.svg)",
      "color": "#ffffff",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "logo_pn_red",
          "label": "Logo PN Red",
          "name": "Logo PN Red",
          "groupId": 13,
          "colorKey": "logo_pn_red",
          "defaultColor": "#da251c",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "logo_pn_blue",
          "label": "Logo PN Blue",
          "name": "Logo PN Blue",
          "groupId": 14,
          "colorKey": "logo_pn_blue",
          "defaultColor": "#007cc2",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "logo_pn_purple",
          "label": "Logo PN Dark Blue",
          "name": "Logo PN Dark Blue",
          "groupId": 15,
          "colorKey": "logo_pn_purple",
          "defaultColor": "#123b8f",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "hooks_object",
      "label": "Three Separate C-Hooks",
      "name": "Three Separate C-Hooks",
      "color": "#ffffff",
      "assembled_z_offset": 0,
      "exploded_z_offset": -8,
      "parts": [
        {
          "id": "separate_hook_left",
          "label": "Left Separate C-Hook",
          "name": "Left Separate C-Hook",
          "groupId": 17,
          "colorKey": "separate_hook_left",
          "defaultColor": "#123b8f",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "separate_hook_center",
          "label": "Center Separate C-Hook",
          "name": "Center Separate C-Hook",
          "groupId": 18,
          "colorKey": "separate_hook_center",
          "defaultColor": "#dc2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "separate_hook_right",
          "label": "Right Separate C-Hook",
          "name": "Right Separate C-Hook",
          "groupId": 19,
          "colorKey": "separate_hook_right",
          "defaultColor": "#38bdf8",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        }
      ]
    },
    {
      "id": "hanging_straps_object",
      "label": "Three Straps and White Text",
      "name": "Three Straps and White Text",
      "color": "#ffffff",
      "assembled_z_offset": 0,
      "exploded_z_offset": -8,
      "parts": [
        {
          "id": "hanging_strap_left",
          "label": "Left Strap with Eyelet Hole",
          "name": "Left Strap with Eyelet Hole",
          "groupId": 2,
          "colorKey": "hanging_strap_left",
          "defaultColor": "#123b8f",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "hanging_strap_center",
          "label": "Center Strap with Eyelet Hole",
          "name": "Center Strap with Eyelet Hole",
          "groupId": 3,
          "colorKey": "hanging_strap_center",
          "defaultColor": "#dc2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "hanging_strap_right",
          "label": "Right Strap with Eyelet Hole",
          "name": "Right Strap with Eyelet Hole",
          "groupId": 4,
          "colorKey": "hanging_strap_right",
          "defaultColor": "#38bdf8",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "strap_text_left",
          "label": "Left White Text",
          "name": "Left White Text",
          "groupId": 5,
          "colorKey": "strap_text_left",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "strap_text_center",
          "label": "Center White Text",
          "name": "Center White Text",
          "groupId": 6,
          "colorKey": "strap_text_center",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        },
        {
          "id": "strap_text_right",
          "label": "Right White Text",
          "name": "Right White Text",
          "groupId": 7,
          "colorKey": "strap_text_right",
          "defaultColor": "#ffffff",
          "assembled_z_offset": 0,
          "exploded_z_offset": -8,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Round Badge with Strap Hanger",
      "targetGroupId": -1,
      "default": true
    }
  ]
};
